import React from "react";
import { Link, useLocation } from "react-router-dom";
import { postFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { ToastContainer, toast } from "react-toastify";
import { useUser } from "../../context/UserContext";
import { Tooltip } from "flowbite-react";
import { useLanguage } from "../../context/LanguageContext";

interface LocationState {
  id: string;
  image: string;
  title: string;
  description: string;
  endDate: string;
  eValue: number;
}

const OfferDetail: React.FC = () => {
  const {t} = useLanguage();
  const location = useLocation();
  const state = location.state as LocationState;
  const { user }: any = useUser();

  if (!state) {
    return <div>Error: No offer details provided.</div>;
  }

  const { id, image, title, description, endDate } = state;

  const joinCampaign = async () => {
    try {
      const response = await postFetcher(
        endpoints.user.addUserSpecialCampaign,
        {
          arg: {
            campaignId: id,
          },
        }
      );
      if (response.result) {
        toast.success(t('toastMessage', 'campSuc'));
      } else {
        if (response.message === "User already in the special campaign.") {
          toast.info(t('toastMessage', 'campExist'));
        } else if (response.message === "Special campaign date is not valid.") {
          toast.info(t('toastMessage', 'campDate'));
        } else {
          toast.error(t('toastMessage', 'campErr'));
        }
      }
    } catch (error) {
      console.error("Error joining campaign:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="p-4 md:p-8 h-full shadow-lg rounded-lg bg-white overflow-y-auto">
        <Link
          to="/profile/special"
          className="text-primary-color font-medium text-sm mb-4 inline-block"
        >
          {"< Geri Dön"}
        </Link>
        <div className="w-full h-96 overflow-hidden rounded-xl">
          <img src={image} alt={title} className="w-full h-full object-cover" />
        </div>
        <div className="py-5">
          <h1 className="text-3xl font-bold text-red-700 mb-4">{title}</h1>
          <p className="text-gray-800 mb-4">{description}</p>
          <p className="text-gray-600">Kampanya Bitiş Tarihi: {endDate}</p>
        </div>

        {user?.ePara && user?.ePara - state.eValue > 0 ? (
          <button
            onClick={joinCampaign}
            className="py-2 px-10 bg-primary-color text-white font-semibold rounded-lg hover:bg-red-800 transition"
          >
            KATIL
          </button>
        ) : (
          <Tooltip content="Kampanyaya Katılmak İçin E-Para Bakiyeniz Yetersiz">
            <button
              // onClick={handleClickEValueMessage}
              className="py-2 px-10 bg-gray-300 text-white font-semibold rounded-lg  transition cursor-no-drop"
            >
              KATIL
            </button>
          </Tooltip>
        )}
      </div>
    </>
  );
};

export default OfferDetail;
